const BlogArticle = {
  init: function () {
    if (
      !document.querySelector(".template-article") ||
      document.querySelector(".template-article.suffix-")
    )
      return

    this.positionAuthor()
    this.initProductSlick()
  },

  positionAuthor: function () {
    const sections = document.querySelectorAll("main .shopify-section")
    if (sections.length < 1) return

    let targetEl = document.querySelectorAll("main .shopify-section")[1]
    if (!targetEl.querySelector(".articleV2RT__side")) return

    let fragment = document.createDocumentFragment()
    fragment.appendChild(document.querySelector(".articleAuthor"))
    targetEl.querySelector(".articleV2RT__side").prepend(fragment)
    document.querySelector(".articleAuthor").classList.remove("hidden")
  },

  initProductSlick: function () {
    if (!$.fn.slick) {
      setTimeout(() => {
        this.initProductSlick()
      }, 100)
    }

    if (!document.querySelector(".articleV2Products")) return

    document
      .querySelectorAll(".articleV2Products .articleV2Products__slick")
      .forEach((pEl) => {
        $(pEl).slick({
          dots: false,
          arrows: false,
          draggable: false,
          slidesToShow: 3,
          infinite: false,
          responsive: [
            {
              breakpoint: 736,
              settings: {
                dots: false,
                arrows: false,
                draggable: true,
                slidesToShow: 1.25,
                infinite: false,
              },
            },
          ],
        })
      })
  },
}

export default BlogArticle
